import React from "react";
import { MessageCircle } from "lucide-react";
import { BRAND } from "@/data/site";

export function WhatsAppButton() {
  return (
    <a
      href={BRAND.whatsapp}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-teal px-4 py-3 text-white shadow-lg animate-pulse-ring hover:bg-teal-dark transition-colors"
    >
      <MessageCircle className="h-6 w-6" />
      <span className="hidden sm:inline font-semibold text-sm">Chat with us</span>
    </a>
  );
}
